// Auto-generated by scripts/generate-customer-logos.mjs

export type CustomerLogo = { name: string; src: string };

export const customerLogos: CustomerLogo[] = [
  {
    "name": "AB InBev",
    "src": "/img/logos/abinbevlogo.png"
  },
  {
    "name": "Agaval",
    "src": "/img/logos/agavallogo.png"
  },
  {
    "name": "Coca-Cola",
    "src": "/img/logos/cocacolalogo.png"
  },
  {
    "name": "Grupo Crystal",
    "src": "/img/logos/crystallogo.png"
  },
  {
    "name": "Gloria",
    "src": "/img/logos/glorialogo.jpeg"
  },
  {
    "name": "Omint",
    "src": "/img/logos/omint%20logo.png"
  },
  {
    "name": "Prevención",
    "src": "/img/logos/prevencion%20logo.png"
  },
  {
    "name": "Tramarsa",
    "src": "/img/logos/tramarsalogo.png"
  },
  {
    "name": "Yamaha",
    "src": "/img/logos/yamahalogo.svg"
  }
];
